// LogSink interface lives in @skaile/workspaces/types so consumers can type-check
// sink instances without depending on core. Runtime errors live here.
export type { LogSink } from "@skaile/workspaces/types";

export class LogStoreDisabledError extends Error {
  constructor() {
    super("LogStore is disabled (mode=off); query is unavailable");
    this.name = "LogStoreDisabledError";
  }
}
